export class FormUI {
  showFieldError(field: HTMLElement, message: string): void {
    const errorDiv = field.parentElement?.querySelector('.field-error') || this.createErrorElement();
    errorDiv.textContent = message;
    field.parentElement?.appendChild(errorDiv);
    field.classList.add('border-red-500');
  }

  clearFieldError(field: HTMLElement): void {
    const errorDiv = field.parentElement?.querySelector('.field-error');
    errorDiv?.remove();
    field.classList.remove('border-red-500');
  }

  clearAllErrors(form: HTMLFormElement): void {
    form.querySelectorAll('.field-error').forEach(error => error.remove());
    form.querySelectorAll('.border-red-500').forEach(field => {
      field.classList.remove('border-red-500');
    });
    form.querySelector('.character-count')?.remove();
  }

  showMessage(messageDiv: HTMLDivElement | null, message: string, type: 'success' | 'error'): void {
    if (!messageDiv) return;

    messageDiv.classList.remove('hidden');
    messageDiv.className = 'form-message mt-4 p-4 rounded';

    if (type === 'success') {
      messageDiv.classList.add('bg-green-100', 'text-green-800', 'border', 'border-green-200');
    } else {
      messageDiv.classList.add('bg-red-100', 'text-red-800', 'border', 'border-red-200');
    }

    messageDiv.textContent = message;

    setTimeout(() => {
      messageDiv?.classList.add('hidden');
    }, 10000);
  }

  updateCharacterCount(textarea: HTMLTextAreaElement, maxLength: number): void {
    const currentLength = textarea.value.length;
    
    let countDiv = textarea.form?.querySelector('.character-count') as HTMLDivElement;
    if (!countDiv) {
      countDiv = document.createElement('div');
      countDiv.className = 'character-count text-xs text-certlex-grey mt-1';
      textarea.parentElement?.appendChild(countDiv);
    }

    countDiv.textContent = `${currentLength} / ${maxLength} Zeichen`;

    if (currentLength > maxLength) {
      countDiv.classList.add('text-red-600');
    } else {
      countDiv.classList.remove('text-red-600');
    }
  }

  setLoadingState(form: HTMLFormElement, button: HTMLButtonElement | null, isLoading: boolean): void {
    if (!button) return;

    button.disabled = isLoading;

    if (isLoading) {
      button.textContent = 'Wird gesendet...';
      form.classList.add('opacity-75', 'pointer-events-none');
    } else {
      button.textContent = button.getAttribute('data-original-text') || 'Absenden';
      form.classList.remove('opacity-75', 'pointer-events-none');
    }
  }

  storeOriginalButtonText(button: HTMLButtonElement | null): void {
    if (button) {
      button.setAttribute('data-original-text', button.textContent || 'Absenden');
    }
  }

  private createErrorElement(): HTMLDivElement {
    const div = document.createElement('div');
    div.className = 'field-error text-xs text-red-600 mt-1';
    return div;
  }
}